export default "/images/codan.avif?480d1488aef8c847e8b2464410a1f30f";